import { isNil, startsWith } from 'lodash'

const website = (site) => {
  if (isNil(site) || site === '') return ''

  if (site.split('.').length > 1) {
    if (startsWith(site, 'http://') || startsWith(site, 'https://')) {
      return site
    }

    return `https://${site}`
  }
  return site
}

export default website
